import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/shoptrendz/node_modules/@mui/material/esm/Box/Box.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/shoptrendz/node_modules/@mui/material/esm/Typography/Typography.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/shoptrendz/src/components/AiOverview.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/shoptrendz/src/components/DataBoard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/shoptrendz/src/components/filterBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/shoptrendz/src/components/FiltersLoadingGate.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FiltersDataProvider"] */ "/home/ubuntu/shoptrendz/src/context/FiltersDataContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/shoptrendz/src/layout/FiltersUrlSyncClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/shoptrendz/src/layout/sideBar.tsx");
